// @ts-nocheck
import React from "react";
import { FaUsers } from "react-icons/fa";
import useFetch from "../../../ApiClient/GetApi";
import Leftbar from "../layout/Leftbar";
import Topbar from "../layout/Topbar";
import Card from "./homeElements/Card";
import { FiPackage } from "react-icons/fi";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { FcInTransit } from "react-icons/fc";
import { HiDocumentCheck } from "react-icons/hi2";
import { LiaShippingFastSolid } from "react-icons/lia";
import {
  LuPackageCheck,
  LuPackagePlus,
  LuPackageSearch,
  LuPackageX,
} from "react-icons/lu";
import { BsCashCoin } from "react-icons/bs";

export default function Home() {
  const { data } = useFetch("dashboard");
  return (
    <>
      <Leftbar />
      <Topbar main="Dashboard" extend={false} />
      <section className="relative xl:w-[calc(100%-280px)] w-[calc(100%-240px)] top-[148px] py-12 px-10 float-right space-y-8">
        <div>
          <h2 className="text-xl font-semibold text-themeBlue mb-4">Orders</h2>
          <div className="grid xl:grid-cols-4 lg:grid-cols-3 grid-cols-2 gap-5">
            <Card
              quantity={data?.data?.orders ?? 0}
              title="All Orders"
              size="54"
              colorScheme="bg-themeGray2"
              Icon={FiPackage}
            />
            <Card
              quantity={data?.data?.Created ?? 0}
              title="Created Orders"
              size="54"
              colorScheme="bg-yellow-300"
              Icon={LuPackagePlus}
            />
            <Card
              quantity={data?.data?.Arrived ?? 0}
              title="Arrived"
              size="54"
              colorScheme="bg-pink-500"
              Icon={LuPackageCheck}
            />
            <Card
              quantity={data?.data?.ArrivedAtLocalHub ?? 0}
              title="Arrived At LocalHub"
              size="54"
              colorScheme="bg-orange-400"
              Icon={LuPackageCheck}
            />
            <Card
              quantity={data?.data?.ReachedWarehouse ?? 0}
              title="Reached At Warehouse"
              size="54"
              colorScheme="bg-yellow-600"
              Icon={LuPackageX}
            />
            <Card
              quantity={data?.data?.ReadyToShip ?? 0}
              title="Ready To Ship"
              size="54"
              colorScheme="bg-purple-800"
              Icon={LiaShippingFastSolid}
            />
            <Card
              quantity={data?.data?.InTransit ?? 0}
              title="InTransit Orders"
              size="54"
              colorScheme="bg-purple-400"
              Icon={FcInTransit}
            />
            <Card
              quantity={data?.data?.Delivered ?? 0}
              title="Delivered Orders"
              size="54"
              colorScheme="bg-green-400"
              Icon={LuPackageCheck}
            />
            <Card
              quantity={data?.data?.Completed ?? 0}
              title="Completed Orders"
              size="54"
              colorScheme="bg-green-400"
              Icon={LuPackageCheck}
            />
            <Card
              quantity={data?.data?.Delayed ?? 0}
              title="Delayed Orders"
              size="54"
              colorScheme="bg-teal-400"
              Icon={LuPackageSearch}
            />
            <Card
              quantity={data?.data?.Incomplete ?? 0}
              title="Incomplete Orders"
              size="54"
              colorScheme="bg-red-600"
              Icon={LuPackageX}
            />
            <Card
              quantity={data?.data?.Cancelled ?? 0}
              title="Cancelled Orders"
              size="54"
              colorScheme="bg-red-600"
              Icon={LuPackageX}
            />
          </div>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-themeBlue mb-4">Users</h2>
          <div className="grid xl:grid-cols-4 lg:grid-cols-3 grid-cols-2 gap-5">
            <Card
              quantity={data?.data?.users ?? 0}
              title="All Users"
              size="75"
              colorScheme="bg-black"
              Icon={FaUsers}
            />
          </div>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-themeBlue mb-4">Invoices & Payments</h2>
          <div className="grid xl:grid-cols-4 lg:grid-cols-3 grid-cols-2 gap-5">
            <Card
              quantity={data?.data?.InvoiceGenerated ?? 0}
              title="Generated Invoice"
              size="54"
              colorScheme="bg-cyan-400"
              Icon={LiaFileInvoiceSolid}
            />
            <Card
              quantity={data?.data?.InvoicePaid ?? 0}
              title="Paid Invoices"
              size="54"
              colorScheme="bg-yellow-600"
              Icon={HiDocumentCheck}
            />
            <Card
              quantity={data?.data?.PendingPayment ?? 0}
              title="Pending Payment"
              size="54"
              colorScheme="bg-black"
              Icon={BsCashCoin}
            />
          </div>
        </div>
      </section>
    </>
  );
}
